var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","right":"0","top":"-5px"}},[_c('el-tooltip',{attrs:{"effect":"dark"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\r\n      "+_vm._s(_vm.messages)+"\r\n    ")]),_vm._v(" "),_c('i',{staticClass:"el-icon-question",staticStyle:{"margin-left":"5px","font-size":"16px"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5631f498","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PromptMessage/index.vue
// module id = null
// module chunks = 